import { FC, memo } from 'react';
import { Box, Typography } from '@mui/material';

interface IProps {
  title: string;
  description?: string;
  eyebrow?: string;
  mb?: number | string;
}

const StepTitle: FC<IProps> = ({ title, description, eyebrow, mb = 3 }) => (
  <Box mb={mb}>
    {eyebrow && <span className="cpg-kicker">{eyebrow}</span>}
    <Typography
      variant="h6"
      className="cpg-card-title"
    >
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        className="cpg-card-sub"
      >
        {description}
      </Typography>
    )}
  </Box>
);

export default memo(StepTitle);
